<script setup lang="ts">
import { computed } from 'vue';
import { useSsoUrls } from '~/composables/use-sso-urls';

const props = defineProps<{
  eventId: string;
}>();

const route = useRoute();

// Round-trip back to this event with `?commit=1` so the commit dialog
// auto-resumes after sign-in (see `useCommitResume`).
const redirectTo = computed(() => `${route.path}?commit=1`);
const source = computed(() => ({ type: 'event', id: props.eventId }));

const { googleSsoUrl, facebookSsoUrl } = useSsoUrls(
  redirectTo,
  source,
  'event_page',
);

function goToEmailLogin() {
  navigateTo(
    `/login?redirect_to=${encodeURIComponent(redirectTo.value)}` +
      `&event_id=${encodeURIComponent(props.eventId)}`,
  );
}
</script>

<template>
  <div>
    <p class="text-body-2 text-medium-emphasis mb-3">
      Sign in to commit to this event.
    </p>
    <AuthSsoButtons :google-url="googleSsoUrl" :facebook-url="facebookSsoUrl" />
    <v-btn variant="tonal" block size="large" @click="goToEmailLogin">
      Continue with email
    </v-btn>
  </div>
</template>
